import ApiService from '../apiservice'

export default class StatusRecursoApensoService extends ApiService {
  constructor() {
    super('/statusRecursoApenso');
  }

  listar() {
    return this.get('/all');
  }
}